var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1",
    keyTimes: "0;0.475;0.95;1",
    repeatCount: "indefinite",
    values: "0 150;42 150;42 150;42 150"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1",
    keyTimes: "0;0.475;0.95;1",
    repeatCount: "indefinite",
    values: "0;-16;-59;-59"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "2s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 12 12;360 12 12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loadingSpinner.1bafbaf66b1375889f1626141fb2cab2.svg";
export { ForwardRef as ReactComponent };